

export var serverPathMain = "https://jumingyoujian.cn";
// export var serverPathMain = "http://localhost";
export var serverPath = serverPathMain + "/aboge_Admin_qiche/public/index.php";

